import { em } from "csx";
import { Component } from "react";
import * as React from "react";
import { style } from "typestyle";
import { classNames } from "./utils.js";
const pushButtonStyle = style({
    display: "inline-flex",
    flexFlow: "row nowrap",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "transparent",
    borderRadius: em(1.5),
    padding: "0.5em 1.25em",
    border: "1px solid var(--color-foreground)",
    fontWeight: 500,
    fontSize: em(1.25),
    color: "inherit",
    $nest: {
        "&:active": {
            filter: "brightness(1.25)",
        },
        "i:first-child": {
            marginRight: em(0.25),
        },
        "&:disabled": {
            opacity: 0.5,
        },
    },
    cursor: "pointer",
});
const primaryStyle = style({
    backgroundColor: "var(--color-primary)",
    color: "#fff",
    border: "1px solid var(--color-primary)",
});
const secondaryStyle = style({
    backgroundColor: "transparent",
    border: "1px solid var(--color-foreground)",
});
const dangerStyle = style({
    backgroundColor: "var(--color-error)",
    color: "#fff",
    border: "1px solid var(--color-error)",
});
const successStyle = style({
    backgroundColor: "var(--color-success)",
    color: "#fff",
    border: "1px solid var(--color-success)",
});
const fullWidthStyle = style({
    width: "100%",
});
export class PushButton extends Component {
    render() {
        const { onClick, icon, primary = false, secondary = false, danger = false, success = false, fullWidth = false, className, class: buttonClass, ...buttonProps } = this.props;
        const classes = [
            pushButtonStyle,
            primary && primaryStyle,
            secondary && secondaryStyle,
            danger && dangerStyle,
            success && successStyle,
            fullWidth && fullWidthStyle,
            className,
            buttonClass,
        ];
        return (React.createElement("button", { onClick: e => {
                e.stopPropagation();
                if (this.props.onClick)
                    this.props.onClick();
            }, className: classNames(...classes), ...buttonProps },
            icon,
            this.props.children));
    }
}
//# sourceMappingURL=PushButton.js.map